import React from 'react';
import { Chip, Stack } from '@mui/material';
import { EntityOption } from '../../hooks/useEntityOptions.props';

interface EntityFilterChipsProps {
  options: EntityOption[];
  selected: string[];
  onToggle: (value: string) => void;
}

// Shows only the selected entities' rows; with none selected every row shows.
const EntityFilterChips = ({ options, selected, onToggle }: EntityFilterChipsProps) => (
  <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" data-testid="cfl-entity-chips">
    {options.map(({ value, label }) => {
      const isSelected = selected.includes(value);
      return (
        <Chip
          key={value}
          label={label}
          color="primary"
          variant={isSelected ? 'filled' : 'outlined'}
          aria-pressed={isSelected}
          onClick={() => onToggle(value)}
          clickable
        />
      );
    })}
  </Stack>
);

export default EntityFilterChips;
